import React, { FC, useState } from 'react';
import classNames from 'classnames';
import { Pagination } from 'antd';

import { MTDIcon } from '../../Icon';

import styles from './Pagination.module.scss';

type onChangeType = (page: number, pageSize: number) => void;

export interface Props {
  pageSize?: number;
  current?: number;
  preText?: string;
  nextText?: string;
  total: number;
  onChange: onChangeType;
}

export interface H5Props {
  className?: string;
  defaultCurrent?: number;
  defaultPageSize: number;
  preText?: string;
  nextText?: string;
  total: number;
  onChange: onChangeType;
}

export const H5Pagination: FC<H5Props> = (props) => {
  const { className, defaultCurrent, defaultPageSize, total, preText, nextText, onChange } = props;
  const finalPreText = preText || '上一页';
  const finalNextText = nextText || '下一页';

  const totalPager = Math.ceil(total / defaultPageSize);

  const [current, setCurrentValue] = useState(defaultCurrent || 1);
  const [preDisabled, setPreDisabled] = useState(current <= 1);
  const [nextDisabled, setNextDisabled] = useState(current >= totalPager);

  const onHandleSetCurrent = (currentValue: number) => {
    setCurrentValue(currentValue);
    setPreDisabled(currentValue <= 1);
    setNextDisabled(currentValue >= totalPager);
    onChange?.(currentValue, defaultPageSize);
  };

  const onClickPre = () => {
    if (preDisabled) return;
    onHandleSetCurrent(current - 1);
  };

  const onClickNext = () => {
    if (nextDisabled) return;
    onHandleSetCurrent(current + 1);
  };

  const preCls = classNames(styles['pager-item'], styles['pre-handle'], preDisabled && styles['pager-item-disabled']);
  const nextCls = classNames(
    styles['pager-item'],
    styles['next-handle'],
    nextDisabled && styles['pager-item-disabled'],
  );

  return (
    <div className={className}>
      <div className={preCls} onClick={onClickPre}>
        <MTDIcon icon="mtdicon-left-thick" height="18px" width="18px" />
        <div className={styles['pre-text']}>{finalPreText}</div>
      </div>
      <div className={classNames(styles['pager-item'], styles['page-content'])}>
        <div className={styles['page-current']}>{current}</div>
        <div className={styles['page-split']}>/</div>
        <div className={styles['page-total']}>{totalPager}</div>
      </div>
      <div className={nextCls} onClick={onClickNext}>
        <div className={styles['next-text']}>{finalNextText}</div>
        <MTDIcon icon="mtdicon-right-thick" height="18px" width="18px" />
      </div>
    </div>
  );
};

const PaginationComp: FC<Props> = (props) => {
  const { current, pageSize, total, onChange, preText, nextText } = props;

  const finalPageSize = pageSize || 10;

  const pcPager = (
    <Pagination
      className={styles['pc-pagination-container']}
      defaultCurrent={current}
      defaultPageSize={finalPageSize}
      total={total}
      showSizeChanger={false}
      onChange={onChange}
    />
  );

  const h5Pager = (
    <H5Pagination
      className={styles['h5-pagination-container']}
      defaultCurrent={current}
      defaultPageSize={finalPageSize}
      total={total}
      preText={preText}
      nextText={nextText}
      onChange={onChange}
    />
  );

  return (
    <div className={styles['pagination-container']}>
      {pcPager}
      {h5Pager}
    </div>
  );
};

export default PaginationComp;
